<template>
    <EqsDialog
        v-model="dialogProxy"
        closable
        v-bind="{
            attachToVApp: true,
            title: $t('secondary-market.add-order'),
            subtitle: $t('secondary-market.add-order-subtitle'),
            confirm: {
                fn: importOffering,
                txt: $t('capital-increase.user.dashboard.import-btn')
            },
            cancel: {
                fn: () => (dialogProxy = false)
            }
        }"
    >
        <template #default="{ loading: loadingImport }">
            <EqsText
                class="py-3"
                :value.sync="offeringID"
                v-bind="{
                    loading: loadingImport,
                    label: $t('secondary-market.import-id-label'),
                    errorMessages: offeringDirty ? 'invalid ID' : null
                }"
                @input="() => (offeringDirty = false)"
            />
        </template>
    </EqsDialog>
</template>

<script>
export default {
    name: "ImportDialog",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            offeringID: "",
            validID: false,
            offeringDirty: false
        };
    },
    computed: {
        dialogProxy: {
            get() {
                return this.value;
            },
            set(val) {
                if (!val) {
                    this.$emit("close");
                }
                this.$emit("update:value", val);
            }
        }
    },
    methods: {
        async importOffering() {
            try {
                const res = await this.$api.addSecondaryMarketSellOrder(this.offeringID);
                if (res.data.detail === "Market sell order imported")
                    this.$ui.success(
                        this.$t("ui.message.success.imported-offering", {
                            offeringID: this.offeringID
                        })
                    );
                else {
                    this.$ui.info(
                        this.$t("ui.message.info.offering-list-user", {
                            offeringID: this.offeringID
                        })
                    );
                }
                this.offeringID = "";
            } catch (e) {
                this.offeringDirty = true;
                if (e.status === 404) {
                    this.$ui.error(this.$t("ui.message.info.offering-list-user-failed"));
                }
                throw e;
            }
        }
    }
};
</script>
